import { createAction } from 'actions/utils'

export const ADD_LOGIC_NODE = 'ADD_LOGIC_NODE'
export const addLogicNode = createAction(ADD_LOGIC_NODE, [
  'nodeType',
  'nextIndex',
  'logicDetails',
])

export const ADD_LOGIC_NODE_TO_OUTPUT = 'ADD_LOGIC_NODE_TO_OUTPUT'
export const addLogicNodeToOutput = createAction(ADD_LOGIC_NODE_TO_OUTPUT, [
  'nodeType',
  'nextIndex',
  'fnId',
  'outputId',
])

export const DELETE_LOGIC_NODE = 'DELETE_LOGIC_NODE'
export const deleteLogicNode = createAction(DELETE_LOGIC_NODE, ['uri'])

export const RESET_LOGIC_NODE = 'RESET_LOGIC_NODE'
export const resetLogicNode = createAction(RESET_LOGIC_NODE, [
  'uri',
  'nodeType',
])
